import {
  Component,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, filter } from 'rxjs/operators';
import {
  getOpenState,
  getLiveState,
  MarketDrawerRootReducerState
} from '../../state/reducer';
import { SetDealDateAction, ResetDataAction } from '../../state/actions';

@Component({
  selector: 'muni-gameday-market-drawer',
  templateUrl: './market-drawer.template.html',
  styleUrls: ['./market-drawer.styles.scss'],
  standalone: false,
})
export class MarketDrawerComponent implements OnDestroy, OnChanges {
  _dealDate: Date;
  @Input()
  set dealDate(date: Date) {
    if (date) {
      this.store.dispatch(new SetDealDateAction(date));
    }
  }
  public readonly open: Observable<boolean> = this.store.pipe(
    map(getOpenState),
    distinctUntilChanged()
  );
  public readonly isLive: Observable<boolean> = this.store.pipe(
    map(getLiveState),
    filter((live) => live)
  );

  constructor(private store: Store<MarketDrawerRootReducerState>) {}

  public ngOnChanges(changes: SimpleChanges): void {
    const dateChange = changes.dealDate;

    const currentDate = dateChange.currentValue
      ? dateChange.currentValue.getTime()
      : undefined;
    const previousDate = dateChange.previousValue
      ? dateChange.previousValue.getTime()
      : undefined;

    if (previousDate && currentDate && currentDate !== previousDate) {
      this.store.dispatch(new SetDealDateAction(dateChange.currentValue));
    }
  }

  public ngOnDestroy(): void {
    this.store.dispatch(new ResetDataAction());
  }
}
